import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/api";
import { sleep } from "@/shared/utils";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { ReactNode } from "react";
import { Caja } from "@/shared/types/caja";

export interface CajaEditRequest {
    nombre: string,
}

export async function editCaja(id: string, request: CajaEditRequest): Promise<Caja> {
    await sleep(1000);
    const response = await api.put("cajas/" + id, request);
    return response.data;
}

export function useEditCajaMutation(id: string, mutationConfig: MutationConfig<Caja, CajaEditRequest> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: async (request: CajaEditRequest) => await editCaja(id, request),
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["cajas"] });
        },
    })
}

export interface EditCajaMutationProps{
    id: string, 
    mutationConfig?: MutationConfig<Caja, CajaEditRequest>,
    children?:(mutationResult:MutationResult<Caja, CajaEditRequest>)=>ReactNode
}

export function EditCajaMutation({
    id,
    children,
    mutationConfig
}:EditCajaMutationProps){
    const mutationResult = useEditCajaMutation(id, mutationConfig);
    return children&&children(mutationResult)
}